import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE } from "@/config/site";
import { COMPANY } from "@/i18n/legal";
import { SEO_BASE } from "@/i18n/seo";

// Site-wide JSON-LD: Organization + WebSite. Rendered once at app root.
export const StructuredData = () => {
  const sameAs = Object.values(SITE.social || {}).filter((u) => u && u.startsWith("http") && !u.includes("wa.me"));

  const organization = {
    "@context": "https://schema.org",
    "@type": ["Organization", "OnlineStore"],
    "@id": `${SEO_BASE}/#organization`,
    name: COMPANY.brand,
    legalName: COMPANY.legalName,
    url: SEO_BASE,
    logo: `${SEO_BASE}/vornx/logo_mark.jpg`,
    image: `${SEO_BASE}/vornx/signature_lineup_v2.jpg`,
    email: COMPANY.email,
    vatID: `IT${COMPANY.vat}`,
    taxID: COMPANY.taxCode,
    address: {
      "@type": "PostalAddress",
      streetAddress: "Viale XXV Aprile, 31",
      addressLocality: "Caprarola",
      addressRegion: "VT",
      postalCode: "01032",
      addressCountry: "IT",
    },
    contactPoint: {
      "@type": "ContactPoint",
      email: COMPANY.email,
      contactType: "customer support",
      availableLanguage: ["it", "en", "de", "es", "fr"],
    },
    ...(sameAs.length ? { sameAs } : {}),
  };

  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SEO_BASE}/#website`,
    name: COMPANY.brand,
    url: SEO_BASE,
    inLanguage: ["it", "en", "de", "es", "fr"],
    publisher: { "@id": `${SEO_BASE}/#organization` },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organization)}</script>
      <script type="application/ld+json">{JSON.stringify(website)}</script>
    </Helmet>
  );
};
